import { render, staticRenderFns } from "./DashboardListStatusOverview.vue?vue&type=template&id=201a03d4&"
import script from "./DashboardListStatusOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardListStatusOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201a03d4')) {
      api.createRecord('201a03d4', component.options)
    } else {
      api.reload('201a03d4', component.options)
    }
    module.hot.accept("./DashboardListStatusOverview.vue?vue&type=template&id=201a03d4&", function () {
      api.rerender('201a03d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/dashboard/DashboardListStatusOverview.vue"
export default component.exports